import { atTimeOfEvent } from '../strings.locstring.json';
import { noReminder } from 'owa-locstrings/lib/strings/noreminder.locstring.json';
import loc from 'owa-localize';
import ReminderOptionType from '../helpers/ReminderOptionType';
import getAllDayReminderString from './getAllDayReminderString';

import { DefaultReminderOffsets } from './emailReminderConsts';

export default function getAllDayReminderOption(includeNoReminder: boolean): ReminderOptionType[] {
    const {
        NO_REMINDER,
        AT_TIME_OF_EVENT,
        DAY_OF_EVENT_MIN,
        DAY_BEFORE_MORNING_MIN,
        DAY_BEFORE_MIN,
        WEEK_BEFORE_MIN,
    } = DefaultReminderOffsets;
    return ([
        // No ReminderOptionType
        includeNoReminder
            ? {
                  key: NO_REMINDER,
                  text: loc(noReminder),
              }
            : null,
        // At time of the event
        {
            key: AT_TIME_OF_EVENT,
            text: loc(atTimeOfEvent),
        },
        // Day of event at 9:00 AM
        {
            key: DAY_OF_EVENT_MIN,
            text: getAllDayReminderString(DAY_OF_EVENT_MIN),
        },
        // Day before at 9:00 AM
        {
            key: DAY_BEFORE_MORNING_MIN,
            text: getAllDayReminderString(DAY_BEFORE_MORNING_MIN),
        },
        // Day before at 5:00 PM
        {
            key: DAY_BEFORE_MIN,
            text: getAllDayReminderString(DAY_BEFORE_MIN),
        },
        // 1 week before at 9:00 AM
        {
            key: WEEK_BEFORE_MIN,
            text: getAllDayReminderString(WEEK_BEFORE_MIN),
        },
    ] as ReminderOptionType[]).filter(option => !!option);
}
